module.exports = __webpack_public_path__ + "assets/img/img.146655c9.jpg";